import css from 'styled-jsx/css';

const styles = css.global`#open-finance-vantagens {
  padding: 40px 0;
  background: linear-gradient(88deg, #600 -1.54%, #970000 23.92%, #C00 102.37%);
  overflow: hidden;
}

#open-finance-vantagens .ctn-home-24 {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

#open-finance-vantagens .vantagens-titulo {
  color: #FFF;
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
}

#open-finance-vantagens .custom-carousel .embla__container {
  max-width: 816px;
  margin: auto;
}

#open-finance-vantagens .slide {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 240px;
  height: 232px;
  padding: 24px 24px 20px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #fff;
  margin-right: 16px;
  flex: 0 0 240px;
}

#open-finance-vantagens .slide .slide-titulo {
  color: #C00;
  text-align: center;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  margin: 0;
}

#open-finance-vantagens .slide .slide-texto {
  color: #444;
  text-align: center;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; 
}

#open-finance-vantagens .home-pagination {
  margin-top: 24px;
  max-width: 256px;
  width: 100%;
}

#open-finance-vantagens .home-pagination .embla__prev.enable-mobile-arrows, 
#open-finance-vantagens .home-pagination .embla__next.enable-mobile-arrows {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}

#open-finance-vantagens .home-pagination .embla__prev {
  background-image: url(assets/open-finance/vantagens/ic_arrow_left.svg);
}

#open-finance-vantagens .home-pagination .embla__next {
  background-image: url(assets/open-finance/vantagens/ic_arrow_right.svg);
}

@media (min-width: 992px) {
  #open-finance-vantagens {
    padding: 64px 0;
    background: linear-gradient(88deg, #600 -1.54%, #970000 23.92%, #C00 102.37%);
  }

  #open-finance-vantagens .ctn-home-24 {
    align-items: center;
    gap: 48px;
  }

  #open-finance-vantagens .vantagens-titulo {
    font-size: 40px;
    line-height: 60px;
  }

  #open-finance-vantagens .slide {
    margin-right: 48px;
  }

  #open-finance-vantagens .slide:last-child {
    margin-right: 0;
  }

  #open-finance-vantagens .home-pagination {
    display: none;
  }
}`;

export default styles;